export function showField(resultset, fieldName, fieldValue) {
    return fieldValue || resultset?.fieldsChangedList?.some(x => x === fieldName.toLowerCase());
}